import {useEffect, useState} from 'react'
import {QueryStatus, QueryStatusType} from 'src/types'
import {OperacionAFOCL} from "../types/types";
import { HttpAFOCL } from '../api/httoAFOCL';

type UseOperacionResult<TOperacion> = {
    status: QueryStatusType
    operacion: TOperacion | undefined
}

export const useOperacionAFOCL: (idOperacion: number) => UseOperacionResult<OperacionAFOCL> = (idOperacion: number) => {
    const [status, setStatus] = useState<QueryStatus>(QueryStatus.Idle)
    const [operacion, setOperacion] = useState<OperacionAFOCL>()

    useEffect(() => {
        setStatus(QueryStatus.Loading)

        HttpAFOCL.get(idOperacion)
            .then(data => {
                setOperacion(data)
                setStatus(QueryStatus.Success)
            })
            .catch(() => setStatus(QueryStatus.Error))
    }, [idOperacion])

    return {status, operacion}
}
